
// @ is an alias to /src
import axios from "axios";
import { Component, Vue, Watch } from "vue-property-decorator";
import WizardLogo from "@/views/_components/WizardLogo.vue";
import WizardCart from "@/views/_components/WizardCart.vue";
import WizardFooter from "@/views/_components/WizardFooter.vue";
import WizardHomeLayout from "@/views/pages/WizardHomeLayout.vue";
import WizardOne from "@/views/pages/WizardOne.vue";
import CheckoutProgress from "@/views/_components/CheckoutProgress.vue";
import QuickCartPreviewMobile from "@/views/_components/QuickCartPreviewMobile.vue";
import { namespace } from "vuex-class";
import WizardTwo from "@/views/pages/WizardTwo.vue";
import WizardThree from "@/views/pages/WizardThree.vue";
import WizardFour from "@/views/pages/WizardFour.vue";
import WizardEnd from "@/views/_components/WizardEnd.vue";
import UserInfo from "@/views/_components/UserInfo.vue";
import IUser from "@/models/protocols/IUser";
import Loader from "@/components/Loader.vue";
import WizardCartWindow from "@/views/_components/WizardCartWindow.vue";
import { Cart } from "../types/Cart";
import state from "../store/root/state";
import { Country } from "../types/Country";
import UnderMaintenance from "./_components/UnderMaintenance.vue";

const { State } = namespace("Root");

@Component({
  components: {
    WizardLogo,
    WizardCart,
    WizardFooter,
    WizardHomeLayout,
    WizardOne,
    WizardTwo,
    WizardThree,
    WizardFour,
    WizardEnd,
    CheckoutProgress,
    QuickCartPreviewMobile,
    UserInfo,
    Loader,
    WizardCartWindow,
    UnderMaintenance,
  },
})
export default class WizardHome extends Vue {
  @State("cart") cart: any;
  @State("user") user!: IUser;

  current_route: any;
  state_by_zip: string;

  constructor() {
    super();
    this.current_route = Vue.router.currentRoute.name;
    this.state_by_zip = "";
  }

  @Watch("$route")
  onPropertyChanged() {
    this.changeRouteVariable();
  }

  changeRouteVariable() {
    this.current_route = Vue.router.currentRoute.name;
  }

  created() {
    this.includeHotJarScript();
  }

  mounted() {
    this.state_by_zip = "";
    if (this.$route.query.zip !== undefined) {
      this.fetchStateForZipCode(this.$route.query.zip);
    }
    if (this.$route.query.utm_source !== undefined) {
      this.cart.utm_source = this.$route.query.utm_source;
    }
  }

  includeHotJarScript() {
    let script = document.createElement("script");
    let data =
      "(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:" +
      process.env.HJID +
      ",hjsv:" +
      process.env.HJSV +
      "};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r)})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";
    script.type = "text/javascript";
    try {
      // doesn't work on ie...
      script.appendChild(document.createTextNode(data));
    } catch (e) {
      // IE has funky script nodes
      script.text = data;
    }
    document.body.appendChild(script);
  }

  async fetchStateForZipCode(zip): Promise<void> {
    let url = "https://api.zippopotam.us/us/" + zip;
    await axios
      .get(url)
      .then((response) => {
        const { status, data } = response;
        if (
          status == 200 &&
          response.data["places"] !== undefined &&
          response.data["places"][0] !== undefined &&
          response.data["places"][0]["state"] !== undefined
        ) {
          this.state_by_zip = response.data["places"][0]["state abbreviation"];
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log("fetchStateForZipCode error");
      });
  }
}
